import { createContext, useContext } from 'react'

export enum LandReportMapDataLayer {
  ACRES = 'acres',
  PERFORMANCE = 'stability',
  SOIL = 'soil',
  ELEVATION = 'elevation',
}

export interface LandReportViewState {
  dataLayer: LandReportMapDataLayer
  focusYear: number
  setDataLayer: (dataLayer: LandReportMapDataLayer) => void
  setFocusYear: (year: number) => void
}

export const LandReportViewContext = createContext<LandReportViewState>({
  dataLayer: LandReportMapDataLayer.ACRES,
  focusYear: 0,
  setDataLayer: console.log,
  setFocusYear: console.log,
})
LandReportViewContext.displayName = 'LandReportViewContext'

export const useLandReportView = () => useContext(LandReportViewContext)
